// extracted by mini-css-extract-plugin
export default {"wrapper":"SmsList_wrapper__rJhEI","search":"SmsList_search__hswef"};